import { useEffect, useState } from 'react';
import styles from './topDrivers.module.css';
import axios from 'axios';


const drivers = [
    { rank: 1, name: "Khriesiu", trips: 13, notifications: 17 },
    { rank: 2, name: "C. Rhamtsomo", trips: 6, notifications: 18 },
    { rank: 3, name: "Sherhotho", trips: 4, notifications: 11 },
    { rank: 4, name: "Thepfu", trips: 4, notifications: 11 },
    { rank: 5, name: "Seyiekhrietuo", trips: 4, notifications: 8 },
    { rank: 6, name: "Heakwang Konyak isbt", trips: 4, notifications: 8 },
    { rank: 7, name: "Thepfuvor Yiese", trips: 4, notifications: 8 },
    { rank: 8, name: "Atouzo Metha", trips: 3, notifications: 11 },
    { rank: 9, name: "Lalboi Gangte", trips: 3, notifications: 8 },
    { rank: 10, name: "Neikese", trips: 2, notifications: 4 },

    { rank: 1, name: "Khriesiu", trips: 13, notifications: 17 },
    { rank: 2, name: "C. Rhamtsomo", trips: 6, notifications: 18 },
    { rank: 3, name: "Sherhotho", trips: 4, notifications: 11 },
    { rank: 4, name: "Thepfu", trips: 4, notifications: 11 },
    { rank: 5, name: "Seyiekhrietuo", trips: 4, notifications: 8 },
    { rank: 6, name: "Heakwang Konyak", trips: 4, notifications: 8 },
    { rank: 7, name: "Thepfuvor Yiese", trips: 4, notifications: 8 },
    { rank: 8, name: "Atouzo Metha", trips: 3, notifications: 11 },
    { rank: 9, name: "Lalboi Gangte", trips: 3, notifications: 8 },
    { rank: 10, name: "Neikese", trips: 2, notifications: 4 },

    { rank: 1, name: "Khriesiu", trips: 13, notifications: 17 },
    { rank: 2, name: "C. Rhamtsomo", trips: 6, notifications: 18 },
    { rank: 3, name: "Sherhotho", trips: 4, notifications: 11 },
    { rank: 4, name: "Thepfu", trips: 4, notifications: 11 },
    { rank: 5, name: "Seyiekhrietuo", trips: 4, notifications: 8 },
    { rank: 6, name: "Heakwang Konyak", trips: 4, notifications: 8 },
    { rank: 7, name: "Thepfuvor Yiese", trips: 4, notifications: 8 },
    { rank: 8, name: "Atouzo Metha", trips: 3, notifications: 11 },
    { rank: 9, name: "Lalboi Gangte", trips: 3, notifications: 8 },
    { rank: 10, name: "Neikese", trips: 2, notifications: 4 }
];

const TopDrivers = () => {
    // const [drivers, setDrivers] = useState();
    const fetch = async () => {
        const url = `${process.env.REACT_APP_URL}/api/drivers/fetchTopDrivers`;
        try {
            const result = await axios.get(url, {
                withCredentials: true
            })
            console.log(result);
        } catch (error) {
            console.log(error);
        }


    }
    useEffect(() => {
        fetch();
    }, []);

    const headers = Object.keys(drivers[0]);

    return (
        <div className={styles.container}>
            <div className={styles.subcontainer}>
                <div className={styles.header}>
                    <h2 className={styles.heading}>
                        Driver of the Month
                    </h2>
                    <h4 className={styles.heading}>UraDrive</h4>
                </div>

                <div className={styles.tablecon}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                {headers.map(h =>
                                    <th key={h}>{h}</th>
                                )}
                            </tr>
                        </thead>

                        <tbody>
                            {drivers.map(d => (
                                <tr key={d.name}>
                                    {headers.map(h => (
                                        <td key={h} className={styles.cell}>{d[h]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopDrivers;
